import React from "react";
import {
  Alert,
  Box,
  Button,
  FormControlLabel,
  InputAdornment,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import LinkRoundedIcon from "@mui/icons-material/LinkRounded";

export default function ImportSourceStep({
  sourceMode,
  onSourceModeChange,
  file,
  onFileChange,
  googleUrl,
  onGoogleUrlChange,
  busy,
  onContinue,
  maxColumns = 80,
}) {
  const canContinue = sourceMode === "file" ? Boolean(file) : Boolean(String(googleUrl || "").trim());

  return (
    <Stack spacing={2.5}>
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 900 }}>Elegí la fuente</Typography>
        <Typography variant="body2" color="text.secondary">
          Podés subir un CSV/XLSX o leer una planilla pública de Google Sheets. Máximo 10 MB, 5.000 filas y {maxColumns} columnas por lote.
        </Typography>
      </Box>

      <RadioGroup row value={sourceMode} onChange={(event) => onSourceModeChange(event.target.value)}>
        <FormControlLabel value="file" control={<Radio />} label="Archivo CSV / XLSX" />
        <FormControlLabel value="google" control={<Radio />} label="Google Sheets público" />
      </RadioGroup>

      {sourceMode === "file" ? (
        <Stack spacing={1.5}>
          <Button
            component="label"
            variant="outlined"
            startIcon={<UploadFileRoundedIcon />}
            disabled={busy}
            sx={{ alignSelf: "flex-start", textTransform: "none", fontWeight: 800 }}
          >
            {file ? "Cambiar archivo" : "Seleccionar archivo"}
            <input
              hidden
              type="file"
              accept=".csv,.xlsx,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              onChange={(event) => onFileChange(event.target.files?.[0] || null)}
            />
          </Button>
          {file ? (
            <Alert severity="success">
              <strong>{file.name}</strong> · {(file.size / 1024 / 1024).toFixed(2)} MB
            </Alert>
          ) : null}
        </Stack>
      ) : (
        <TextField
          fullWidth
          label="URL pública de Google Sheets"
          placeholder="https://docs.google.com/spreadsheets/d/..."
          value={googleUrl}
          onChange={(event) => onGoogleUrlChange(event.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LinkRoundedIcon color="action" />
              </InputAdornment>
            ),
          }}
          helperText="La planilla debe poder abrirse sin iniciar sesión. WebProfit sólo leerá el enlace público de Google Sheets."
          disabled={busy}
        />
      )}

      <Alert severity="info">
        La primera fila con contenido se interpreta como encabezado. El archivo no se guarda en localStorage y el borrador temporal se elimina al cancelar o vencer.
      </Alert>

      <Button
        variant="contained"
        onClick={onContinue}
        disabled={!canContinue || busy}
        sx={{ alignSelf: "flex-end", textTransform: "none", fontWeight: 900 }}
      >
        {busy ? "Leyendo fuente…" : "Leer encabezados y muestra"}
      </Button>
    </Stack>
  );
}
